/*
 *
 * ZendeskVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_ZENDESK } from './constants';

export const initialState = {
  isVerify: true,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const zendeskVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_ZENDESK.START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_ZENDESK.SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_ZENDESK.ERROR:
        draft.isVerify = false;
        draft.error = true;
        break;
    }
  });
};

export default zendeskVerifyReducer;
